import "./App.css";
import NavBar from "./componentes/NavBar";
import React from "react";
import Inicio from "./componentes/Inicio.js";



function App() {

    return (
      <div className="App">
        <NavBar />
        <Inicio />
      </div>
    );
}

export default App;
